"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlMat4Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float matrix4 uniform.
 */
class GlMat4Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniformMatrix4fv(this.uniformLocation, this.transpose, data);
        this.isDirty = false;
    }
}
exports.GlMat4Uniform = GlMat4Uniform;
//# sourceMappingURL=gl-mat4-uniform.js.map